<template>
    <div :class="'user ' + (links_open ? 'open' : '')">
        <div class="avatar">
            <img :src="avatarSrc" />
        </div>
        <div class="info">
            <span class="name" v-html="displayName"></span>
            <div class="integration">
                <div class="integration--item">
                    <div class="line" v-if="config.integration.availability >= 0">
                        <span>Credito</span>
                        <span class="value">&nbsp;€ {{ config.integration.availability }}</span>
                    </div>
                </div>
                <div v-if="false" class="integration--item content">
                    <div class="line">
                        <a @click="mixinLogout()">Logout</a>
                    </div>
                </div>
            </div>
        </div>
        <div class="toggler" @click="links_toggle">
            <div v-if="false" v-html="chevron_down"></div>
        </div>
    </div>
</template>

<script>
    import Vue from 'vue'
    import { chevron_down } from '@/components/svg/chevrons'
    export default {
        name: 'user',
        components:
        {
        },
        computed:
        {
        },
        created()
        {
            this.chevron_down = chevron_down
            window.addEventListener('scroll', () => {
                this.links_open = false
            })
            document.addEventListener('click', () => {
                this.links_open = false
            })
        },
        data()
        {
            return {
                config: Vue.prototype.$config,
                avatarSrc: '',
                displayName: '',
                links_open: false,
            }
        },
        mounted()
        {
            this.avatarSrc = (this.config.integration ? this.config.integration.avatarSrc : '')
            this.displayName = (this.config.integration ? this.config.integration.displayName : '')

        },
        methods:
        {
            links_toggle(e)
            {
                e.stopPropagation()
                this.links_open = !this.links_open
                return false
            }
        },
    }
</script>

<style lang="scss">
    .user
    {
        display:flex;
        font-size: 14px;//16px;
        font-weight: 500;
        line-height: 140%;
        .avatar
        {
            width:40px;
            margin-right:20px;
            img
            {
                max-width:100%;
                height:auto;
            }
        }
        .info
        {
            .line
            {
                min-width: 100%;
            }
        }
        .name
        {

        }
        .integration
        {
            &--item
            {
                display:flex;
                flex-wrap: wrap;
            }
            .content
            {
                font-size: 14px;
            }
        }
        .value
        {
            color:$primary;
            font-weight: bold;
        }
        .toggler
        {
            display:none;
            &>div
            {
                min-width:40px;
                min-height:40px;
            }
            path
            {
                transition: $transition-base;
                transform-origin:center center;
            }
        }

        @include media-breakpoint-up(lg)
        {
            position:relative;
            .content
            {
                display:none;
                position:absolute;
                top:100%;
                right:0;
                margin-top:2rem;
                background:$white;
                padding:$border-radius-lg;
                border-radius:$border-radius-lg;
                li
                {
                    white-space:nowrap;
                }
            }
            .toggler
            {
                display:inline-flex;
                align-items:center;
                justify-content: center;
            }
            
            &.open
            {
                .toggler svg
                {
                    transform:rotate(180deg);
                }
                .content
                {
                    display:block;
                }
            }

        }
    }
</style>